export default "__VITE_ASSET__9ce5e898__"